module.exports = __webpack_public_path__ + "img/pencil-outline-grey.4f06a512.svg";